<template>
    <div class="cc-step">
        <div class="cc-content cc-content--login" v-if="shouldLoginBeShown">
            <login/>
        </div>
        <div class="cc-content cc-content--registration">
            <registration/>
        </div>
        <div class="cc-content cc-content--controls">
            <div class="cc-step-controls">
                <div class="cc-step-controls__section cc-step-controls__section--left">
                    <a href="javascript:void(0);" class="cc-button cc-button--blue" @click="$emit('setActiveStep', activeStep - 1)">{{ translations['Backward'] }}</a>
                </div>
                <div class="cc-step-controls__section cc-step-controls__section--right">
                    <a href="javascript:void(0);" class="cc-button cc-button--orange" @click="$emit('setActiveStep', activeStep + 1)">{{ translations['Forward'] }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    import Login from "./Login";
    import Registration from "./Registration";

    export default {
        components: {
            Login,
            Registration,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                isUserLoggedIn: state => state.isLoggedIn,
                activeStep: state => state.activeStep,
            }),
            shouldLoginBeShown: function () {
                return !this.isUserLoggedIn;
            },
        },
        mounted () {
            $('input[type=checkbox]').uniform();
        },
        name: 'Step3',
    };
</script>

<style lang="scss">
    #app {
        div {
            &.checker {
                display: inline;

                span {
                    top: 1px;
                }
            }
        }
    }
</style>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-content {
            display: block;
            width: 100%;

            &.cc-content--login {
                max-width: 500px;
                margin-top: 5rem;
                margin-right: auto;
                margin-left: auto;
            }

            &.cc-content--registration {
                max-width: 500px;
                margin-right: auto;
                margin-left: auto;
            }

            &.cc-content--controls {
                max-width: 100%;
                margin-top: 5rem;
            }
        }
    }
</style>
